<template>
  <div class="h-fill bg-f3f" style="height:100%">
    <!-- 主页header -->
    <Header></Header>
    <!-- 相似内容  学习助手闪卡笔记区域 -->
    <common-item></common-item>
    <!-- 中间学习方案区域 -->
    <study-program></study-program>
    <!-- 相似内容  没有盲点和冲刺高分区域 -->
    <common-item></common-item>
    <!-- 版本下载区域 -->
    <down-load-version></down-load-version>
    <!-- 首页底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/index/Header.vue'
import Footer from '../components/index/Footer.vue'
import DownLoadVersion from '../components/index/DownLoadVersion.vue'
import StudyProgram from '../components/index/StudyProgram.vue'
import CommonItem from '../components/index/CommonItem.vue'

export default {
  name: "Index",
  components: {
    Header,
    Footer,
    DownLoadVersion,
    StudyProgram,
    CommonItem
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {

  }
}
</script>

<style scoped>

</style>
